module.exports = __webpack_public_path__ + "img/Zeelogo.770638c7.png";